"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const format_1 = __importDefault(require("date-fns/format"));
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const utilities_1 = require("jsAssets/utilities");
const echo_1 = require("jsAssets/websocket/echo");
const lodash_1 = require("lodash");
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const user_task_notifications_1 = __importDefault(require("../../../js/components/user-task-notifications"));
const AssetActionsComponent_1 = __importDefault(require("../../reviews/components/AssetActionsComponent"));
const CommentsComponent_1 = __importDefault(require("../../reviews/components/CommentsComponent"));
const index_1 = __importDefault(require("../../reviews/components/ReviewInstructionComponent/index"));
const ReviewStagesDetail_1 = __importDefault(require("../../reviews/components/ReviewStagesDetail"));
const helper_1 = require("../../reviews/helper");
const helpers_1 = require("../helpers");
const assetDetailSlice_1 = require("../store/assetDetailSlice");
const commentSlice_1 = require("../store/commentSlice");
const reviewSlice_1 = require("../store/reviewSlice");
const ticketSlice_1 = require("../store/ticketSlice");
const asset_detail_content_modules_less_1 = __importDefault(require("./asset-detail-content.modules.less"));
const asset_tabs_1 = __importDefault(require("./asset-tabs"));
const current_assigned_reviewer_1 = __importDefault(require("./workflow-tab/current-assigned-reviewer"));
const withPublicLinkModal_1 = __importDefault(require("../../reviews/HOC/withPublicLinkModal"));
const TicketHistoryPanel = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./ticket-history-panel'))));
const ASSET_CATALOGUE_PROJECTS = [996, 997, 998, 999, 1000];
const UNAVAILABLE_REVIEW_STATUSES = ['failed', 'processing', 'uploading'];
const defaultTime = Number((_a = helpers_1.WEBSOCKET_CONFIG === null || helpers_1.WEBSOCKET_CONFIG === void 0 ? void 0 : helpers_1.WEBSOCKET_CONFIG.default_polling_time) !== null && _a !== void 0 ? _a : 15000);
let idNewRoundSocket = 0;
const AssetDetailContent = ({ renderFilesStructure, roundId, ticketId, isVisible, openPublicLinkModal, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { asset, isZiflow } = (0, react_redux_1.useSelector)((state) => state.assetDetail);
    const { assetDetail } = (0, react_redux_1.useSelector)((state) => state);
    const { comments, ziflowActivities } = (0, react_redux_1.useSelector)((state) => state.assetComments);
    const { showTicketHistoryPanel } = (0, react_redux_1.useSelector)((state) => state.ticketHistory);
    const { data: ticket } = (0, react_redux_1.useSelector)((state) => state.ticket);
    const [tagMenuPlacement, setTagMenuPlacement] = (0, react_1.useState)('right');
    const [isPolling, setIsPolling] = (0, react_1.useState)(false);
    const { reviewRound, idNewRound, blockRound, availableReviewZiflow, accordionReviewStageStatePath, } = (0, react_redux_1.useSelector)((state) => state.review);
    const [instructions, setInstructions] = (0, react_1.useState)(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.instructions);
    const intervalRef = (0, react_1.useRef)(0);
    const project = asset === null || asset === void 0 ? void 0 : asset.projectTypeId;
    let compareActivityData;
    const isSuperuser = (helpers_1.CURRENT_USER === null || helpers_1.CURRENT_USER === void 0 ? void 0 : helpers_1.CURRENT_USER.authenticate) === 5;
    const isAssetCatalogueProject = project && ASSET_CATALOGUE_PROJECTS.includes(project);
    const isDocumentApproval = !!(asset === null || asset === void 0 ? void 0 : asset.invoice);
    const isWorkflow = Boolean(ticket === null || ticket === void 0 ? void 0 : ticket.workflow);
    const isKeyDocument = (asset === null || asset === void 0 ? void 0 : asset.keyDocument) === 1;
    const workflowRule = (ticket === null || ticket === void 0 ? void 0 : ticket['workflow-rule']) || null;
    const instruction = workflowRule === null || workflowRule === void 0 ? void 0 : workflowRule.instructions;
    const ticketStatus = (ticket === null || ticket === void 0 ? void 0 : ticket.ticketStatus) || null;
    const dueDate = (((_a = asset === null || asset === void 0 ? void 0 : asset.invoice) === null || _a === void 0 ? void 0 : _a.due_date) || ((_b = ticket === null || ticket === void 0 ? void 0 : ticket.dueDate) === null || _b === void 0 ? void 0 : _b.date)) &&
        (0, format_1.default)((0, parseISO_1.default)(((_c = asset === null || asset === void 0 ? void 0 : asset.invoice) === null || _c === void 0 ? void 0 : _c.due_date) || ((_d = ticket === null || ticket === void 0 ? void 0 : ticket.dueDate) === null || _d === void 0 ? void 0 : _d.date)), 'dd/MM/yyyy');
    const reviewTitle = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.title;
    const assetStatusColor = (0, helpers_1.getAssetStatusColor)(asset === null || asset === void 0 ? void 0 : asset.status);
    const jobClient = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobOffice;
    const jobBrand = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobBrand;
    const enableReassignApproval = (_e = asset === null || asset === void 0 ? void 0 : asset.client) === null || _e === void 0 ? void 0 : _e.enable_reassign_approval;
    const isFinanceNotUnderWorkflow = isDocumentApproval && !isWorkflow;
    const assignedReviewers = [];
    let assignedReviewersSort = [];
    if (ticket) {
        if (ticket.users) {
            ticket.users.forEach((user) => {
                assignedReviewers.push({ id: user.id, name: user.name });
            });
        }
        if (ticket.groups) {
            ticket.groups.forEach((group) => {
                assignedReviewers.push({
                    id: group.group_id,
                    name: group.group_name,
                });
            });
        }
        assignedReviewersSort = (0, orderBy_1.default)(assignedReviewers, ['name']);
    }
    const handleListenerEventUpdateRoundStages = (e) => {
        const newRound = e.detail;
        if (newRound) {
            dispatch((0, reviewSlice_1.setReviewRound)(newRound));
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('update-review-round', handleListenerEventUpdateRoundStages);
        return () => {
            document.removeEventListener('update-review-round', handleListenerEventUpdateRoundStages, false);
        };
    }, []);
    const [activities, setActivities] = (0, react_1.useState)([]);
    const handleListenerEventUpdateInstructions = (e) => {
        var _a;
        const newInstructions = ((_a = e.detail) !== null && _a !== void 0 ? _a : '');
        if (newInstructions) {
            setInstructions(newInstructions);
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('update-review-round', handleListenerEventUpdateRoundStages);
        return () => {
            document.removeEventListener('update-review-round', handleListenerEventUpdateRoundStages, false);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) {
            dispatch((0, commentSlice_1.fetchZiflowActivities)({ roundId: Number(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) }));
        }
    }, [reviewRound]);
    (0, react_1.useEffect)(() => {
        const disableViewProof = reviewRound && UNAVAILABLE_REVIEW_STATUSES.includes(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.status);
        dispatch((0, reviewSlice_1.setAvailableReviewZiflow)(!disableViewProof));
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.status]);
    (0, react_1.useEffect)(() => {
        const ziflowEvents = [...ziflowActivities];
        moment_1.default.tz.setDefault(helper_1.USER_TIMEZONE);
        const convertedTimezoneComments = comments.map((comment) => {
            return {
                ...comment,
                date: (0, moment_1.default)(comment.date, ['YYYY-MM-DD h:mm a']).format(),
            };
        });
        const mergedActivities = [
            ...ziflowEvents.reverse(),
            ...convertedTimezoneComments,
        ];
        mergedActivities.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
        const convertedComments = mergedActivities.map((activity) => {
            var _a, _b, _c;
            if (activity.type === 'review-activity-history') {
                const ziflowActivity = activity;
                return {
                    type: 'review-activity-history',
                    avatarUrl: (_a = ziflowActivity.user) === null || _a === void 0 ? void 0 : _a.avatarUrl,
                    userId: (_b = ziflowActivity.user) === null || _b === void 0 ? void 0 : _b.id.toString(),
                    userName: (_c = ziflowActivity.user) === null || _c === void 0 ? void 0 : _c.name,
                    date: ziflowActivity.date,
                    notes: ziflowActivity.activityType,
                    noteId: `ziflowId_${ziflowActivity.date}`,
                };
            }
            return activity;
        });
        setActivities(convertedComments);
    }, [comments, ziflowActivities]);
    (0, react_1.useEffect)(() => {
        // handle re-position of pulse-tag menu
        $(window).on('resize', () => 
        // @ts-ignore
        setTagMenuPlacement($(window).width() <= 787 ? 'left' : 'right'));
    }, []);
    (0, react_1.useEffect)(() => {
        document.addEventListener('update-instructions', handleListenerEventUpdateInstructions);
        return () => {
            document.removeEventListener('update-instructions', handleListenerEventUpdateInstructions, false);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.instructions) {
            setInstructions(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.instructions);
        }
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.instructions]);
    const handleToggleKeyDocument = () => {
        if (!(asset === null || asset === void 0 ? void 0 : asset.assetId)) {
            return;
        }
        dispatch((0, assetDetailSlice_1.setAssetKeyDocument)({
            isKeyDocument: !isKeyDocument,
            assetId: asset.assetId,
        }));
    };
    const openViewProof = () => {
        window.open(`${helpers_1.URLS.app}reviews/view-proof/${(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId)}`, '_blank');
    };
    const onShareView = () => {
        const openUrl = `${helpers_1.URLS.pulse}ajax.php?action=share&assetid=${asset === null || asset === void 0 ? void 0 : asset.assetId}`;
        window.open(openUrl, 'Share for review', 'width=650,height=600');
    };
    /**
     * Handles changes in the tag
     * select for the PulseTag component
     */
    const handleOnChangeTag = (options, actionMeta) => {
        if (isWorkflow && (ticket === null || ticket === void 0 ? void 0 : ticket.ticketid)) {
            dispatch((0, ticketSlice_1.saveTicketTags)({
                ticketId: ticket.ticketid,
                tags: options,
            }));
            return;
        }
        /** Check if the change is removing a tag */
        if ((actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.action) === 'remove-value' && asset) {
            (0, helpers_1.deleteWithConfirmation)(dispatch, (0, assetDetailSlice_1.deleteAssetTag)({
                assetId: asset.assetId,
                tag: actionMeta.removedValue || null,
            }));
            return;
        }
        /** Else assume user is adding a new tag */
        const newTags = options.map((op) => op.label.toString());
        const { assetId } = asset || {};
        if (assetId) {
            dispatch((0, assetDetailSlice_1.saveAssetTags)({ assetId, tags: newTags }));
        }
    };
    /**
     * Handle delete from the PulsWithMore component
     */
    const handleOnDeleteTag = (value) => {
        var _a, _b, _c;
        if (!asset) {
            return;
        }
        const { assetId } = asset;
        if (isWorkflow && (ticket === null || ticket === void 0 ? void 0 : ticket.ticketid)) {
            dispatch((0, ticketSlice_1.deleteTicketTag)({
                ticketId: ticket.ticketid,
                tags: ((_b = (_a = ticket === null || ticket === void 0 ? void 0 : ticket.tags) === null || _a === void 0 ? void 0 : _a.filter((tag) => tag.id !== value)) === null || _b === void 0 ? void 0 : _b.map((tag) => ({ label: tag.name, value: tag.id }))) || [],
            }));
            return;
        }
        (0, helpers_1.deleteWithConfirmation)(dispatch, (0, assetDetailSlice_1.deleteAssetTag)({
            assetId,
            tag: ((_c = asset === null || asset === void 0 ? void 0 : asset.tags) === null || _c === void 0 ? void 0 : _c.find((tag) => tag.value === value)) || null,
        }));
    };
    const onReassignClick = () => {
        var _a, _b;
        const isFinancialWorkflow = !!(asset === null || asset === void 0 ? void 0 : asset.invoice);
        const isFinanceManager = !!((_a = asset === null || asset === void 0 ? void 0 : asset.job) === null || _a === void 0 ? void 0 : _a.is_finance_manager);
        const userTaskNotifications = new user_task_notifications_1.default(helpers_1.CONFIG);
        const assignedTo = assignedReviewers.map((reviewer) => ({
            ...reviewer,
            type: reviewer.type === 'groups' ? 'group' : 'user',
        }));
        const disabledUsers = [];
        if (isFinancialWorkflow && !isFinanceManager) {
            disabledUsers.push(parseInt(helpers_1.CURRENT_USER.id));
        }
        userTaskNotifications.show((_b = asset === null || asset === void 0 ? void 0 : asset.job) === null || _b === void 0 ? void 0 : _b.id, (userIds, groupIds) => dispatch((0, assetDetailSlice_1.assignUserNotificationCallback)({ userIds, groupIds })), assignedTo, [], null, null, true, true, 0, disabledUsers, 'You cannot assign yourself as the approver unless you are part of the Finance Manager group. Please select an alternative user');
    };
    const tags = isWorkflow
        ? (_f = ticket === null || ticket === void 0 ? void 0 : ticket.tags) === null || _f === void 0 ? void 0 : _f.map((tag) => ({
            value: tag.id,
            label: tag.name,
        }))
        : asset === null || asset === void 0 ? void 0 : asset.tags;
    // allow superuser click all project, non-superser can't click with isAssetCatalogueProject
    const isRedirectAssetCatalog = isSuperuser || !isAssetCatalogueProject;
    const redirectPassport = () => {
        var _a;
        if (isRedirectAssetCatalog) {
            window.open(`${helpers_1.URLS.app}passport/${helpers_1.JOB_ID !== null && helpers_1.JOB_ID !== void 0 ? helpers_1.JOB_ID : (_a = asset === null || asset === void 0 ? void 0 : asset.job) === null || _a === void 0 ? void 0 : _a.id}`, '_blank');
        }
    };
    const updatedZiflowComponent = (0, react_1.useMemo)(() => reviewRound && (react_1.default.createElement(ReviewStagesDetail_1.default, { roundStages: reviewRound, accordionReviewStageStatePath: accordionReviewStageStatePath })), [reviewRound, accordionReviewStageStatePath]);
    intervalRef.current = (0, utilities_1.useInterval)(() => {
        if (helpers_1.WEBSOCKET_CONFIG.websocket_enabled) {
            const WEBSOCKET_CONNECTION = (0, echo_1.isEchoConnected)();
            if (WEBSOCKET_CONNECTION) {
                setIsPolling(false);
            }
            else {
                setIsPolling(true);
            }
        }
    }, defaultTime);
    (0, react_1.useEffect)(() => {
        let id;
        if (isPolling && isVisible && roundId > 0) {
            id = (0, utilities_1.useInterval)(() => {
                dispatch((0, reviewSlice_1.fetchUpdateReviewRounds)({ roundId }));
            }, defaultTime);
        }
        return () => {
            clearInterval(id);
        };
    }, [isPolling, isVisible]);
    (0, react_1.useEffect)(() => {
        if (intervalRef.current)
            clearInterval(intervalRef.current);
    }, [reviewRound]);
    // Connect to websocket
    (0, react_1.useEffect)(() => {
        if (idNewRound && Number(idNewRound) > 0) {
            idNewRoundSocket = idNewRound;
        }
        const isRunningWebsocket = helpers_1.WEBSOCKET_CONFIG.websocket_enabled && !isPolling;
        if (isRunningWebsocket) {
            const echo = (0, echo_1.getOrCreateEcho)();
            if (!echo) {
                return undefined;
            }
            echo
                .channel('ziflow-asset-detail')
                .listen('.ziflow-event-activity', (response) => {
                const convertResponse = (0, utilities_1.camelizeKeys)(response.data);
                console.log('Review activity websockets ->>', convertResponse);
                if (!(0, lodash_1.isEqual)(response.data, compareActivityData)) {
                    const addTypeKeyRespone = {
                        ...convertResponse,
                        type: 'review-activity-history',
                    };
                    if (idNewRoundSocket &&
                        Number(idNewRoundSocket) === Number(convertResponse.roundId)) {
                        dispatch((0, commentSlice_1.addZiflowActivity)(addTypeKeyRespone));
                    }
                }
                compareActivityData = response.data;
            });
        }
        return () => {
            if (window.Echo) {
                window.Echo.leaveChannel('ziflow-asset-detail');
            }
        };
    }, [isPolling, idNewRound]);
    (0, react_1.useEffect)(() => {
        if ((reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber) && (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.lastRoundNumber)) {
            dispatch((0, reviewSlice_1.setBlockRound)(reviewRound.lastRoundNumber !== (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber)));
        }
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber, reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.lastRoundNumber]);
    const optionRelatedRound = (0, react_1.useMemo)(() => {
        var _a;
        const optionDefault = {
            icon: true,
            iconPosition: 'right',
        };
        const options = ((reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.relatedRounds) &&
            ((_a = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.relatedRounds) === null || _a === void 0 ? void 0 : _a.map((relatedRound) => {
                const isSelectedRound = relatedRound.id === reviewRound.roundId;
                const showBlockIcon = reviewRound.lastRoundNumber !== relatedRound.roundNumber;
                const icon = showBlockIcon ? 'fal fa-lock' : '';
                return {
                    label: `Round ${relatedRound.roundNumber}`,
                    iconClasses: {
                        icon,
                    },
                    classes: [
                        (0, clsx_1.default)(asset_detail_content_modules_less_1.default['round-options__item'], isSelectedRound && asset_detail_content_modules_less_1.default['round-options__item--selected']),
                    ],
                    onClick: () => {
                        if (window.location.hash && window.history.state) {
                            window.location.hash = `${reviewRound.reviewId || 0}-${relatedRound.roundNumber || 0}`;
                            window.history.replaceState({
                                roundId: (relatedRound === null || relatedRound === void 0 ? void 0 : relatedRound.id) || 0,
                            }, '');
                        }
                        else {
                            dispatch((0, reviewSlice_1.fetchReviewRounds)({ roundId: (relatedRound === null || relatedRound === void 0 ? void 0 : relatedRound.id) || 0 }));
                        }
                    },
                    ...optionDefault,
                };
            }))) ||
            [];
        return options;
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.relatedRound, reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber]);
    const handleCloseAssetDetail = () => {
        window.history.pushState('', '', `#${(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || ''}`);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['asset-detail'] },
            isWorkflow && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { id: "asset-details-advanced" }),
                showTicketHistoryPanel && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", { id: "task-details-history-spinner-loader", className: (0, clsx_1.default)('loading-icon align-center padding') },
                        react_1.default.createElement("span", { "uk-spinner": "ratio:2" })) },
                    react_1.default.createElement(TicketHistoryPanel, { ticketId: (_g = asset === null || asset === void 0 ? void 0 : asset.note) === null || _g === void 0 ? void 0 : _g.ticketid }))))),
            react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__header']) },
                react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['asset-details__meta-ctn'] },
                    react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['asset-detail__assetRoot'] },
                        react_1.default.createElement("span", { className: (0, clsx_1.default)('uk-text-truncate', asset_detail_content_modules_less_1.default['asset-detail__assetTitle']) }, reviewTitle),
                        isZiflow && reviewRound && (react_1.default.createElement(pulse_components_1.PulseChip, { label: reviewRound.decisionStatusLabel || reviewRound.statusLabel, PulseTooltipProps: {
                                TippyProps: {
                                    disabled: true,
                                },
                            } })),
                        isWorkflow && !isZiflow && (react_1.default.createElement(pulse_components_1.PulseChip, { label: ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.name, color: ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.hexcolor, size: "small", sx: { height: 20 } })),
                        isWorkflow && !isZiflow && (react_1.default.createElement(pulse_components_1.PulseChip, { label: asset === null || asset === void 0 ? void 0 : asset.status, color: assetStatusColor, size: "small", sx: { height: 20 } }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__meta']) },
                            react_1.default.createElement("span", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__jobTitle'], isRedirectAssetCatalog &&
                                    asset_detail_content_modules_less_1.default['breadcrumb-item--redirect']), onClick: redirectPassport },
                                `${reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobTitle} [${reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobId}]`,
                                react_1.default.createElement("span", null, "/")),
                            react_1.default.createElement("span", { className: asset_detail_content_modules_less_1.default['asset-detail__meta--small'] },
                                jobClient,
                                react_1.default.createElement("span", null, "/"),
                                jobBrand)))),
                react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['asset-detail__headerActions'] },
                    isZiflow && reviewRound && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", { className: asset_detail_content_modules_less_1.default['round-text'] }, "Round"),
                        react_1.default.createElement(pulse_components_1.PulseMenuButton, { menuButtonData: optionRelatedRound, PulseButtonProps: {
                                label: `${reviewRound.roundNumber}`,
                                iconPosition: 'right',
                                classes: [
                                    asset_detail_content_modules_less_1.default['round-options__label'],
                                    blockRound ? asset_detail_content_modules_less_1.default['round-options__label-locked'] : '',
                                ],
                                iconClasses: {
                                    icon: [
                                        blockRound ? 'fas fa-lock' : 'fas fa-chevron-down',
                                        asset_detail_content_modules_less_1.default[`round-options__label-icon${blockRound ? '-locked' : ''}`],
                                    ],
                                },
                            }, TippyProps: {
                                trigger: 'click',
                                arrow: false,
                            }, classes: {
                                menuCtn: asset_detail_content_modules_less_1.default['round-options'],
                            } }),
                        react_1.default.createElement(pulse_components_1.PulseButtonV3, { onClick: openPublicLinkModal, icon: true, iconClasses: {
                                icon: 'fa-regular fa-link',
                            }, label: 'Public Link', variant: pulse_components_1.V3ButtonVariant.tertiary }),
                        react_1.default.createElement(pulse_components_1.PulseButtonV3, { icon: true, iconClasses: {
                                icon: !availableReviewZiflow
                                    ? 'fa-solid fa-circle-o-notch fa-spin'
                                    : 'fa-solid fa-search',
                            }, label: !availableReviewZiflow ? 'Preparing...' : 'View Proof', onClick: openViewProof, disabled: !availableReviewZiflow, variant: pulse_components_1.V3ButtonVariant.primary }))),
                    react_1.default.createElement(AssetActionsComponent_1.default, { ticketId: ticketId || 0 }),
                    (isWorkflow || isDocumentApproval) && (react_1.default.createElement("div", { className: "uk-flex-middle uk-margin-small-left asset-detail__header-due-date" },
                        react_1.default.createElement("i", { className: "fal fa-calendar due-date__icon" }),
                        react_1.default.createElement("div", { className: "uk-flex uk-flex-row uk-flex-middle" },
                            react_1.default.createElement("label", { className: "uk-margin-remove-bottom uk-text-uppercase font-size-12" }, "Due date"),
                            react_1.default.createElement("span", null, dueDate)))))),
            react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__scrollbar--hidden'], 'uk-grid', 'uk-flex-1') },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__preview'], 'uk-flex', 'uk-flex-column') },
                    react_1.default.createElement(asset_tabs_1.default, null)),
                react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__scrollbar--auto'], 'uk-width-expand@m') },
                    react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['ziflow-component__instruction'] },
                        react_1.default.createElement(index_1.default, { roundId: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id, instructions: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.instructions, roundType: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundType })),
                    isWorkflow && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__current-assigned-reviewer'], 'uk-flex', 'uk-flex-middle', 'uk-padding', 'uk-padding-remove-horizontal') },
                            react_1.default.createElement("label", { className: "font-size-12 uk-text-uppercase uk-margin-remove no-wrap" }, "Current assigned reviewer:"),
                            react_1.default.createElement("div", { className: "uk-flex uk-flex-middle uk-overflow-hidden" },
                                react_1.default.createElement(current_assigned_reviewer_1.default, { assignedReviewers: assignedReviewersSort }),
                                enableReassignApproval &&
                                    (helpers_1.CURRENT_USER.category === 'Operations' ||
                                        helpers_1.CURRENT_USER.category === 'Project Manager') && (react_1.default.createElement("a", { className: "font-size-12 reassign-btn uk-margin-small-left", onClick: onReassignClick }, "Reassign")))),
                        instruction && !isZiflow && (react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_content_modules_less_1.default['asset-detail__instruction'], 'uk-padding') }, instruction)))),
                    react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['ziflow-component__review-stage'] }, updatedZiflowComponent),
                    react_1.default.createElement("div", { className: asset_detail_content_modules_less_1.default['asset-detail__comments'] },
                        react_1.default.createElement(CommentsComponent_1.default, { comments: activities, jobId: (_h = asset === null || asset === void 0 ? void 0 : asset.job) === null || _h === void 0 ? void 0 : _h.jobId, asset: asset })))))));
};
exports.default = (0, withPublicLinkModal_1.default)(AssetDetailContent);
